// Batch 33 · fork ui105 — 105(a) (T4 benchmark, B33A-2 override reason), EN + AR.
// Merged into lib/i18n.js translations (big-file rule: new strings in their own file).
export const I18N_B33_UI = {
  en: {
    materiality: {
      benchmarks: { pbz: "Profit before zakat" },
      overrideReason: "Reason for overriding the calculated overall figure",
      overrideReasonHelp: "The overall materiality differs from benchmark × percentage. Say why the entered figure is used.",
    },
    b33ui: {
      // T7: every upload through Document Review (PDF and images only)
      filesNotAdded: "{n} file(s) not added — only PDF and image files (PDF, PNG, JPG, WEBP) can be uploaded here. Spreadsheets and other client schedules go to the head's lead-sheet attachments (Head folders) or, for related parties, the related-party worksheet.",
    },
  },
  ar: {
    materiality: {
      benchmarks: { pbz: "الربح قبل الزكاة" },
      overrideReason: "سبب تجاوز الرقم الإجمالي المحسوب",
      overrideReasonHelp: "تختلف المادية الإجمالية عن المؤشر المرجعي × النسبة. اذكر سبب استخدام الرقم المُدخل.",
    },
    b33ui: {
      filesNotAdded: "لم يُضف {n} ملف — يمكن هنا رفع ملفات PDF والصور فقط (PDF وPNG وJPG وWEBP). تُرفع جداول البيانات وجداول العميل الأخرى في مرفقات الورقة الرئيسية للبند (مجلدات البنود) أو، للأطراف ذات العلاقة، في ورقة عمل الأطراف ذات العلاقة.",
    },
  },
};

export default I18N_B33_UI;
